import { _ } from "../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * A button with a help text. The help text only appears when the widget is disabled.
 * This is similar to Bootstrap help text for forms.
 *
 * @param {boolean} [enabled] - True when the button is enabled
 * @param {function} [onClick] - Callback invoked when the button is clicked
 * @param {Renderable} [helpText] - Text to display below the button when it's disabled.
 *   As this will be wrapped into a <p> element, it could only be phrasing content (https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#phrasing_content).
 */
export default class ButtonWithHelpText extends Widget {
	constructor({ enabled = false, onClick = () => {}, helpText = "" } = {}) {
		super(...arguments);
		this._enabled = enabled;
		this._onClick = onClick;
		this._helpText = helpText;
	}

	setEnabled() {
		this._enabled = true;
		this.update();
	}

	renderContentOn(html) {
		const options = {
			klass: "btn btn-primary",
			click: this._onClick,
			"data-test": "button-with-help-button",
		};

		if (!this._enabled) {
			options.disabled = true;
		}

		html.span(
			{
				klass: ["button-with-help-text", { enabled: this._enabled }],
				"data-test": "button-with-help",
			},
			html.button(options, _("Confirm")),
			this._enabled ? "" : html.p({ klass: "small" }, this._helpText),
		);
	}
}
